import { ShieldQuestion } from 'lucide-react'
import { useSession } from '../lib/session'

/**
 * Shown when a valid account has no `staff` membership.
 *
 * This is not a login error and must not look like one: the credentials were fine,
 * the account simply has no dashboard access. The usual cause for a principal who
 * has just registered is an email mismatch between the school's invite and the
 * account, so that hint is on screen rather than in a support ticket
 * (26-school-admin-api-handoff.md §2).
 */
export function NoAccess() {
  const { profile, signOut } = useSession()

  return (
    <div className="relative flex min-h-screen items-center justify-center p-6">
      <div className="pointer-events-none fixed inset-0 -z-10 bg-bg" />

      <div className="glass-strong w-full max-w-md rounded-3xl p-8 text-center">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-warn-wash text-warn">
          <ShieldQuestion size={26} />
        </div>

        <h1 className="text-xl font-semibold tracking-tight text-ink">
          No dashboard access
        </h1>
        <p className="mt-2 text-sm text-muted">
          You're signed in as{' '}
          <span className="font-semibold text-ink">{profile?.email ?? 'this account'}</span>,
          but it isn't a member of staff at any school.
        </p>
        <p className="mt-3 text-sm text-muted">
          If your school has invited you, make sure you registered with the same email address
          they used — the invitation is matched on it.
        </p>

        <button
          onClick={() => void signOut()}
          className="mt-6 rounded-2xl bg-surface px-4 py-2.5 text-sm font-semibold text-ink shadow-sm transition hover:bg-surface"
        >
          Sign in with a different account
        </button>
      </div>
    </div>
  )
}
